export const MOBILE_PLATFORMS = ['ios', 'android'];
export const isMobilePlatform = (value) => MOBILE_PLATFORMS.includes(value);
export const MANAGED_SIGN_IN_PROVIDER = 'microsoft';
export const MANAGED_SIGN_IN_SCOPES = ['email'];
export const MICROSOFT_LOGIN_HOST = 'https://login.microsoftonline.com';
export const MICROSOFT_ORGANIZATIONS_AUTHORITY = `${MICROSOFT_LOGIN_HOST}/organizations`;
export const getMicrosoftAuthority = (tenantId) => tenantId === null
    ? MICROSOFT_ORGANIZATIONS_AUTHORITY
    : `${MICROSOFT_LOGIN_HOST}/${tenantId}`;
export const getMicrosoftIssuer = (tenantId) => `${MICROSOFT_LOGIN_HOST}/${tenantId}/v2.0`;
export const getMicrosoftOpenIdConfigurationUrl = (tenantId) => `${MICROSOFT_LOGIN_HOST}/${tenantId}/v2.0/.well-known/openid-configuration`;
export const TOKEN_EXCHANGE_GRANT_TYPE = 'urn:ietf:params:oauth:grant-type:token-exchange';
export const ID_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:id_token';
export const ACCESS_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:access_token';
export var ManagedSignInError;
(function (ManagedSignInError) {
    ManagedSignInError["TENANT_NOT_CONFIGURED"] = "tenant_not_configured";
    ManagedSignInError["TOKEN_INVALID"] = "token_invalid";
    ManagedSignInError["TOKEN_EXPIRED"] = "token_expired";
    ManagedSignInError["TOKEN_REPLAYED"] = "token_replayed";
    ManagedSignInError["EMAIL_UNVERIFIED"] = "email_unverified";
    ManagedSignInError["USER_NOT_ALLOWED"] = "user_not_allowed";
    ManagedSignInError["ORGANISATION_REQUIRED"] = "organisation_required";
})(ManagedSignInError || (ManagedSignInError = {}));
export const isManagedSignInError = (value) => Object.values(ManagedSignInError).includes(value);
export const MANAGED_SIGN_IN_MAX_TOKEN_AGE_SECONDS = 300;
//# sourceMappingURL=managedSignIn.js.map